class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');

      document.dispatchEvent(new CustomEvent('quickview:close'));
    });
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);

class QuickViewButton extends MenuDrawer {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const wrapper = this.closest('.card-wrapper');
      const drawer = wrapper.querySelector('quick-view-drawer');
      if (drawer) {
        drawer.querySelector('summary').click();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      }
      else if (this.dataset.productUrl) {
        window.location.href = this.dataset.productUrl;
      }
    });
  }
}
customElements.define('quick-view-button', QuickViewButton);

class QuickView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, _observer) {
    if (!entries[0].isIntersecting) return;

    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);
    const productUrl = this.dataset.productUrl.split('?')[0];
    const sectionUrl = `${productUrl}?view=modal`;

    fetch(sectionUrl)
      .then(response => response.text())
      .then(responseText => {
        setTimeout(() => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const productElement = responseHTML.querySelector(selector);
          this.setInnerHTML(drawerContent, productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          // Reinitialize Sezzle widget - comprehensive approach
          this.initializeSezzle(drawerContent);
          
          // Dispatch event for apps that listen for DOM changes
          window.dispatchEvent(new Event('resize'));
        }, 200);

        setTimeout(() => {
          drawerContent.classList.add('hide-cover');

          document.dispatchEvent(new CustomEvent('quickview:loaded', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          }));
        }, 500);
      })
      .catch(e => {
        console.error(e);
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }

  initializeSezzle(container) {
    // Load Sezzle static widget bundle from GitHub CDN
    const SEZZLE_BUNDLE_URL = 'https://cdn.jsdelivr.net/gh/sezzle/static-widgets@production/dist/bundle.js';
    
    // Check if bundle already loaded
    if (typeof AwesomeSezzle !== 'undefined') {
      this.renderSezzleWidget(container);
      return;
    }
    
    // Load the static widget bundle
    const script = document.createElement('script');
    script.src = SEZZLE_BUNDLE_URL;
    script.async = true;
    script.onload = () => {
      this.renderSezzleWidget(container);
    };
    document.head.appendChild(script);
  }

  renderSezzleWidget(container) {
    if (!container || !container.isConnected) return;
    if (typeof AwesomeSezzle === 'undefined') return;
    
    // Check if widget already exists
    const existingWidget = container.querySelector('.sezzle-widget, .sezzle-checkout-button-wrapper');
    if (existingWidget) return;

    // Find the price element
    const priceElement = container.querySelector('.price-item--regular, .price-item--sale');
    if (!priceElement) return;

    // Get the price text
    const priceText = priceElement.textContent.trim();
    
    // Create placeholder for Sezzle widget
    const widgetId = 'sezzle-widget-quickview-' + Date.now();
    const widgetPlaceholder = document.createElement('div');
    widgetPlaceholder.id = widgetId;
    widgetPlaceholder.style.marginTop = '8px';
    
    // Find Shop Pay / installment section and insert after it
    const installmentSection = container.querySelector('.installment, [class*="shopify-payment-terms"], shopify-payment-terms');
    if (installmentSection && installmentSection.parentNode) {
      installmentSection.parentNode.insertBefore(widgetPlaceholder, installmentSection.nextSibling);
    } else {
      // Fallback: insert after the price block
      const priceBlock = container.querySelector('.price');
      if (priceBlock && priceBlock.parentNode) {
        priceBlock.parentNode.insertBefore(widgetPlaceholder, priceBlock.nextSibling);
      }
    }
    
    // Initialize Sezzle widget using their API
    try {
      const renderSezzle = new AwesomeSezzle({
        amount: priceText,
        renderElement: widgetId,
        theme: 'light',
        alignment: 'left',
        widgetType: 'product-page',
        fontSize: 13
      });
      renderSezzle.init();
    } catch (e) {
      console.log('Sezzle widget error:', e);
    }
  }
}
customElements.define('quick-view', QuickView);
